/*!
 * devextreme-react
 * Version: 24.2.7
 * Build date: Mon Apr 28 2025
 *
 * Copyright (c) 2012 - 2025 Developer Express Inc. ALL RIGHTS RESERVED
 *
 * This software may be modified and distributed under the terms
 * of the MIT license. See the LICENSE file in the root of the project for details.
 *
 * https://github.com/DevExpress/devextreme-react
 */

"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.TemplateRenderingContext = exports.NestedOptionContext = exports.RestoreTreeContext = exports.RemovalLockerContext = void 0;
const react_1 = require("react");
exports.RemovalLockerContext = (0, react_1.createContext)(undefined);
// eslint-disable-next-line @typescript-eslint/no-extra-parens
exports.RestoreTreeContext = (0, react_1.createContext)(undefined);
exports.NestedOptionContext = (0, react_1.createContext)({
    parentExpectedChildren: {},
    parentFullName: '',
    onChildOptionsReady: () => undefined,
    onNamedTemplateReady: () => undefined,
    getOptionComponentKey: () => 0,
    treeUpdateToken: Symbol('initial tree update token'),
    parentType: 'component',
});
exports.TemplateRenderingContext = (0, react_1.createContext)({
    isTemplateRendering: false,
});
